import React from 'react'
import caretDown from '../../images/caretDownGeneric.svg'
import styles from '../modal.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './images/circle-info-regular-full.svg'

const unitOptions = [
  { label: 'Square foot', value: 'sq ft' },
  { label: 'Acres', value: 'acs' },
  { label: 'Square meter', value: 'sq m' },
  { label: 'Square yard', value: 'sqyd' }
]

function SizeUnitSection ({
  sizeUnitFilter,
  setSizeUnitFilter,
  handleUnitChange
}) {
  return (
    <section className={styles.propertyTypeSection}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.titleSizeSection}>Size</h1>
      </div>

      <div
        className={styles.specialAmenitiesRowContainer}
        style={{ gap: '24px' }}
      >
        {/* Floor Size Section */}
        <div className={styles.amenitiesColumn}>
          <div className={styles.sectionTitleWithIcon}>
            <label className={styles.labelsAmenities}>Floor size</label>
            <Tooltip
              title='Filter by floor size value. Set a minimum and/or maximum and choose a unit.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '.MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Floor size help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <div className={styles.amenitiesRow}>
            <input
              autoComplete='off'
              className={styles.inputAmenities}
              placeholder='Min'
              value={sizeUnitFilter.floorSize.min}
              name='min'
              onChange={e => setSizeUnitFilter(e, 'floorSize')}
            />
            <input
              autoComplete='off'
              className={styles.inputAmenities}
              placeholder='Max'
              value={sizeUnitFilter.floorSize.max}
              name='max'
              onChange={e => setSizeUnitFilter(e, 'floorSize')}
            />
            <div>
              <select
                className={styles.selectSize}
                value={sizeUnitFilter.floorSize.unit}
                name='unit'
                onChange={e => handleUnitChange(e, 'floorSize')}
              >
                {unitOptions.map((option, idx) => (
                  <option key={idx} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <img
                src={caretDown}
                alt='arrow'
                className={styles.customArrowPrice}
              />
            </div>
          </div>
        </div>

        {/* Lot Size Section */}
        <div className={styles.amenitiesColumn}>
          <div className={styles.sectionTitleWithIcon}>
            <label className={styles.labelsAmenities}>Lot size</label>
            <Tooltip
              title='Filter by lot size value. Set a minimum and/or maximum and choose a unit.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '.MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Lot size help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <div className={styles.amenitiesRow}>
            <input
              autoComplete='off'
              className={styles.inputAmenities}
              placeholder='Min'
              value={sizeUnitFilter.lotSize.min}
              name='min'
              onChange={e => setSizeUnitFilter(e, 'lotSize')}
            />
            <input
              autoComplete='off'
              className={styles.inputAmenities}
              placeholder='Max'
              value={sizeUnitFilter.lotSize.max}
              name='max'
              onChange={e => setSizeUnitFilter(e, 'lotSize')}
            />
            <div>
              <select
                className={styles.selectSize}
                value={sizeUnitFilter.lotSize.unit}
                name='unit'
                onChange={e => handleUnitChange(e, 'lotSize')}
              >
                {unitOptions.map((option, idx) => (
                  <option key={idx} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <img
                src={caretDown}
                alt='arrow'
                className={styles.customArrowPrice}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SizeUnitSection
